import { State, initialState } from './reports.state';
import { reportsActionTypes, Actions } from './reports.actions';

// eslint-disable-next-line @typescript-eslint/default-param-last
export function ReportReducer(state = initialState, action: Actions): State {
  switch (action.type) {

    // *****************************************************************
    // Anticipated Expenditures
    // *****************************************************************
    case reportsActionTypes.LOAD_Anticipated_Expenditures_Report_SUCCESS:
      return Object.assign({}, state, { anticipatedExpendituresReport: action.payload });

    case reportsActionTypes.LOAD_Anticipated_Expenditures_Report_As_Csv_SUCCESS:
      return Object.assign({}, state, { anticipatedExpendituresReportCsv: action.payload });

    case reportsActionTypes.Clear_Anticipated_Expenditures_Report_From_State:
      return Object.assign({}, state, { anticipatedExpendituresReport: initialState.anticipatedExpendituresReport });

    // *****************************************************************
    // Component Inventory
    // *****************************************************************
    case reportsActionTypes.LOAD_Component_Inventory_Report_SUCCESS:
      return Object.assign({}, state, { componentInventoryReport: action.payload });

    case reportsActionTypes.LOAD_Component_Inventory_Report_FAILS:
      return Object.assign({}, state, { componentInventoryReport: initialState.componentInventoryReport });

    case reportsActionTypes.Clear_Component_Inventory_Report_From_State:
      return Object.assign({}, state, { componentInventoryReport: initialState.componentInventoryReport });

    // *****************************************************************
    // Component Photos & Details
    // *****************************************************************
    case reportsActionTypes.LOAD_Component_Photos_And_Details_Report_SUCCESS:
      return Object.assign({}, state, { componentPhotosAndDetailsReport: action.payload });

    case reportsActionTypes.LOAD_Component_Photos_And_Details_Report_FAILS:
      return Object.assign({}, state, { componentPhotosAndDetailsReport: initialState.componentPhotosAndDetailsReport });

    case reportsActionTypes.Clear_Component_Photos_And_Details_Report_From_State:
      return Object.assign({}, state, { componentPhotosAndDetailsReport: initialState.componentPhotosAndDetailsReport });

    // *****************************************************************
    // Photos
    // *****************************************************************
    case reportsActionTypes.LOAD_Photos_Report_SUCCESS:
      return Object.assign({}, state, { photosReport: action.payload });

    case reportsActionTypes.LOAD_Photos_Report_FAILS:
      return Object.assign({}, state, { photosReport: initialState.photosReport });

    case reportsActionTypes.Clear_Photos_Report_From_State:
      return Object.assign({}, state, { photosReport: initialState.photosReport });

    // *****************************************************************
    // Percent Funded
    // *****************************************************************
    case reportsActionTypes.LOAD_Percent_Funded_Report_SUCCESS:
      return Object.assign({}, state, { percentFundedReport: action.payload });

    case reportsActionTypes.Clear_Percent_Funding_Report_From_State:
      return Object.assign({}, state, { percentFundedReport: initialState.percentFundedReport });


    // *****************************************************************
    // Plan Report Funding
    // *****************************************************************
    case reportsActionTypes.LOAD_Plan_Funding_Report_SUCCESS:
      return Object.assign({}, state, { planFundingReport: action.payload });

    case reportsActionTypes.Clear_Plan_Funding_Report_From_State:
      return Object.assign({}, state, { planFundingReport: initialState.planFundingReport });

    case reportsActionTypes.LOAD_Plan_Funding_Report_As_Pdf_SUCCESS:
      return Object.assign({}, state, { planFundingReportPdf: action.payload });

    case reportsActionTypes.Clear_Plan_Funding_Report_Pdf_From_State:
      return Object.assign({}, state, { planFundingReportPdf: initialState.planFundingReportPdf });


    // *****************************************************************
    // Disclosure
    // *****************************************************************
    case reportsActionTypes.LOAD_Disclosure_Report_SUCCESS:
      return Object.assign({}, state, { disclosureReport: action.payload });

    case reportsActionTypes.LOAD_Prepared_By_Users_SUCCESS:
      return Object.assign({}, state, { disclosureReportPreparedBy: action.payload });

    case reportsActionTypes.Clear_Disclosure_Report_From_State:
      return Object.assign({}, state, { disclosureReport: initialState.disclosureReport });

    case reportsActionTypes.RUN_Disclosure_Report_SUCCESS:
      return Object.assign({}, state, { disclosureReport: action.payload });

    case reportsActionTypes.LOAD_Disclosure_Plan_SUCCESS:
      return Object.assign({}, state, { disclosurePlanId: action.payload });

    // *****************************************************************
    // Plan Summary
    // *****************************************************************
    case reportsActionTypes.LOAD_PLAN_SUMMARY_REPORT_SUCCESS:
      return Object.assign({}, state, { planSummaryReport: action.payload });

    case reportsActionTypes.CLEAR_PLAN_SUMMARY_REPORT_FROM_STATE:
      return Object.assign({}, state, { planSummaryReport: initialState.planSummaryReport });


    // *****************************************************************
    // Reserve Allocation
    // *****************************************************************
    case reportsActionTypes.LOAD_RESERVE_ALLOCATION_REPORT_SUCCESS:
      return Object.assign({}, state, { reserveAllocationReport: action.payload });

    case reportsActionTypes.CLEAR_RESERVE_ALLOCATION_REPORT_FROM_STATE:
      return Object.assign({}, state, { reserveAllocationReport: initialState.reserveAllocationReport });

    // *****************************************************************
    // Financial Health
    // *****************************************************************
    case reportsActionTypes.LOAD_FINANCIAL_HEALTH_REPORT_SUCCESS:
      return Object.assign({}, state, {
        financialHealthReport: action.payload,
        financialHealthReportLoaded: true
      });

    case reportsActionTypes.CLEAR_FINANCIAL_HEALTH_REPORT_FROM_STATE:
      return Object.assign({}, state, {
        financialHealthReport: initialState.financialHealthReport,
        financialHealthReportLoaded: initialState.financialHealthReportLoaded
      });

    // *****************************************************************
    // Real-Time Financial Health
    // *****************************************************************
    case reportsActionTypes.LOAD_REAL_TIME_FINANCIAL_HEALTH_REPORT_SUCCESS:
      return Object.assign({}, state, {
        realTimeFinancialHealthReport: action.payload,
        realTimeFinancialHealthReportLoaded: true
      });

    case reportsActionTypes.CLEAR_REAL_TIME_FINANCIAL_HEALTH_REPORT_FROM_STATE:
      return Object.assign({}, state, {
        realTimeFinancialHealthReport: initialState.realTimeFinancialHealthReport,
        realTimeFinancialHealthReportLoaded: initialState.realTimeFinancialHealthReportLoaded
      });

    // *****************************************************************
    // Financial Assessment
    // *****************************************************************
    case reportsActionTypes.LOAD_FINANCIAL_ASSESSMENT_REPORT_SUCCESS:
      return Object.assign({}, state, { financialAssessmentReport: action.payload });

    case reportsActionTypes.CLEAR_FINANCIAL_ASSESSMENT_REPORT_FROM_STATE:
      return Object.assign({}, state, { financialAssessmentReport: initialState.financialAssessmentReport });

    // *****************************************************************
    // Reserve Analysis
    // *****************************************************************
    case reportsActionTypes.LOAD_Reserve_Analysis_Report_SUCCESS:
      return Object.assign({}, state, { reserveAnalysisReport: action.payload });

    case reportsActionTypes.Clear_Reserve_Analysis_Report_From_State:
      return Object.assign({}, state, { reserveAnalysisReport: initialState.reserveAnalysisReport });


    // *****************************************************************
    // Dashboard
    // *****************************************************************
    case reportsActionTypes.LOAD_Dashboard_Report_SUCCESS:
      return Object.assign({}, state, { dashboardReport: action.payload });

    case reportsActionTypes.Clear_Dashboard_Report_From_State:
      return Object.assign({}, state, { dashboardReport: initialState.dashboardReport });


    // *****************************************************************
    // Projects Summary
    // *****************************************************************
    case reportsActionTypes.LOAD_Projects_Summary_Report_SUCCESS:
      return Object.assign({}, state, { projectsSummaryReport: action.payload });

    case reportsActionTypes.Clear_Projects_Summary_Report_From_State:
      return Object.assign({}, state, { projectsSummaryReport: initialState.projectsSummaryReport });

    // *****************************************************************
    // Settings
    // *****************************************************************
    case reportsActionTypes.FETCH_Report_Settings_SUCCESS:
    case reportsActionTypes.FETCH_Plan_Report_Settings_SUCCESS:
      return Object.assign({}, state, { reportSettings: action.payload });

    case reportsActionTypes.Clear_Report_Settings_From_State:
      return Object.assign({}, state, { reportSettings: initialState.reportSettings });

    // *****************************************************************
    // Misc
    // *****************************************************************
    case reportsActionTypes.SET_REPORT_LIST_TAB: {
      return Object.assign({}, state, { reportListTab: action.payload });
    }

    case reportsActionTypes.SET_REPORT_LIST_YEAR: {
      return Object.assign({}, state, { reportListYear: action.payload });
    }

    case reportsActionTypes.LOAD_FISCAL_YEARS_SUCCESS: {
      return Object.assign({}, state, { fiscalYears: action.payload });
    }

    case reportsActionTypes.CLEAR_ALL_REPORTS_FROM_STATE: {
      return Object.assign({}, initialState);
    }

    // *****************************************************************
    // Anticipated Expenditures Verification
    // *****************************************************************
    case reportsActionTypes.LOAD_AnticipatedExpendituresVerification_Report_SUCCESS:
      return Object.assign({}, state, { anticipatedExpendituresVerificationReport: action.payload });

    case reportsActionTypes.LOAD_AnticipatedExpendituresVerification_Report_FAILS:
      return Object.assign({}, state, { anticipatedExpendituresVerificationReport: initialState.anticipatedExpendituresVerificationReport });

    case reportsActionTypes.SAVE_AnticipatedExpendituresVerification_Report_SUCCESS:
      return Object.assign({}, state, { anticipatedExpendituresVerificationReport: action.payload });

    // Just keep the "current" State if failure.
    case reportsActionTypes.SAVE_AnticipatedExpendituresVerification_Report_FAILS:
      return Object.assign({}, state, { anticipatedExpendituresVerificationReport: state.anticipatedExpendituresVerificationReport });

    case reportsActionTypes.Clear_AnticipatedExpendituresVerification_Report_From_State:
      return Object.assign({}, state, { anticipatedExpendituresVerificationReport: initialState.anticipatedExpendituresVerificationReport });

    // *****************************************************************
    // Maintenance Reports
    // *****************************************************************   
    case reportsActionTypes.Clear_All_Maintenance_Reports_From_State:
      return Object.assign({}, state, {
        maintenanceTaskDetailsReport: initialState.maintenanceTaskDetailsReport,
        maintenanceEstimatedVsActualsReport: initialState.maintenanceEstimatedVsActualsReport
      });

    case reportsActionTypes.Load_Maintenance_Task_Details_Report_Success:
      return Object.assign({}, state, { maintenanceTaskDetailsReport: action.payload });

    case reportsActionTypes.Load_Maintenance_Estimated_Vs_Actuals_Report_Success:
      return Object.assign({}, state, { maintenanceEstimatedVsActualsReport: action.payload });

    // *****************************************************************
    // Managed Coverage Report
    // *****************************************************************
    case reportsActionTypes.Load_ManagedCoverage_Report_Success:
      return Object.assign({}, state, { managedCoverageReport: action.payload });

    // *****************************************************************
    // Cash Flow Report
    // *****************************************************************
    case reportsActionTypes.Load_CashFlow_Report_Success:
      return Object.assign({}, state, { cashFlowReport: action.payload });

    // *****************************************************************
    // Fully Funded Balance Report
    // *****************************************************************
    case reportsActionTypes.Load_FullyFundedBalance_Report_Success:
      return Object.assign({}, state, { fullyFundedBalanceReport: action.payload });

    default: {
      return state;
    }
  }
}
